export default {
    setNewUserData(state, updatedData) {
        for (let field in state.updatedData) {
            state.updatedData[field] = updatedData[field];
        }
    },
    loadingUser(state) {
        state.loading = true;
    },
    successUser(state, user) {
        state.loading = false;
        state.success = true;
        state.error = false;
        state.data = user;
    },
    errorUser(state, error) {
        state.loading = false;
        state.success = false;
        state.error = error;
        state.data = {};
    },
    resetSuccessUser(state) {
        state.success = false;
    }
};
